export enum PartnershipOnboardingActionTypes {
    SET_ONBOARDING_DETAILS = 'partnership/onboarding/SET_ONBOARDING_DETAILS',
    SET_ACTIVE_STAGE_SCREEN = 'partnership/onboarding/SET_ACTIVE_STAGE_SCREEN',
}
